import React from 'react'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import {
  Icon,
  Radio,
  Collapse,
  Input,
  notification,
  Checkbox,
  Button,
  Tooltip,
} from 'antd'

const TextArea = Input.TextArea

const Panel = Collapse.Panel
const RadioGroup = Radio.Group

const removeHTMLTag = (str: string) => {
  str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
  str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
  str = str.replace(/\n[\s| | ]*\r/g, '\n') // 去除多余空行
  str = str.replace(/ /gi, '') // 去掉
  return str
}

const answerFormatter = (answer: string, n = 9) =>
  answer.length > n
    ? removeHTMLTag(answer).slice(0, n) + '...'
    : removeHTMLTag(answer)

const noNeedStatistics: TitleType[] = ['填空', '综合']

type TitleType = '选择' | '多选' | '判断' | '综合' | '填空'

interface ExerciseCardProps {
  index: number | string
  type: TitleType
  content: string
  options: any[]
  id: string
  exerciseid: string
  is_collected: boolean
  operator: React.ReactChild
  answerApi: any
  hadFeedBack: boolean
  answer_count: number
  examinee_answers: string[]
  onPostAnwser: (i, data) => void
  exam: boolean
  onPostComplete: () => void
}

class ExerciseCard extends ComponentExt<ExerciseCardProps> {
  state = {
    collape: true,
    right: true,
    answer: noNeedStatistics.includes(this.props.type)
      ? this.props.examinee_answers
      : Array(this.props.answer_count || 1).fill(''),
    showAnwser: false,
    reaction: null,
    activeKey: '',
    currentDiffcultyId: -1,
    hadFeedBack: false,
  }

  renderExerciseByType = type => {
    const typeMap = {
      单选: this.renderSingleChoice,
      多选: this.renderMutiChoice,
      填空: this.renderCompletion,
      综合: this.renderIntegration,
      判断: this.renderSingleChoice,
    }

    return typeMap[type] || (() => void 0)
  }

  test = e => {
    const activeKey = e.length ? '1' : ''
    this.setState({
      activeKey,
    })
  }

  async postAnwser(answer) {
    const { index, id, exerciseid, answerApi } = this.props
    if (!this.props.exam) {
      try {
        const reaction = await answerApi.call(this, exerciseid, id, answer)
        this.setState({
          reaction,
          showAnwser: true,
          activeKey: reaction.meta.is_right === '是' ? '' : '1',
        })
        if (reaction.meta.check_is_passed) {
          this.props.onPostComplete()
        }
      } catch (e) {}
    }
    this.props.onPostAnwser(Number(index) - 1, answer)
  }

  handleChoice = e => {
    const answer = [e.target.value]
    this.setState({
      answer,
    })
    this.postAnwser(answer)
  }

  handleMutiChoice = e => {
    const answer = e
      .sort()
      .toString()
      .replace(/,/g, '')
    this.setState({
      answer: [answer],
    })
  }
  handleCompletionInput = (e, idx) => {
    const answer = this.state.answer

    answer[idx] = e.target.value
    this.setState({
      answer,
    })
  }
  handleInput = e => {
    const answer = [e.target.value]
    this.setState({
      answer,
    })
  }
  handleConfirm = () => {
    const { answer } = this.state
    const { type } = this.props
    let result = answer.slice()
    if (type === '填空') {
      result = [
        answer.reduce((prev, current) => {
          return `${prev} ${current}`
        }, ''),
      ]
    }
    this.postAnwser(this.state.answer)
  }

  handleEmpty = () => {
    this.setState({
      answer: '',
    })
  }

  handlePostTitleDiffculty = async (diffculty, index) => {
    const id = this.props.id
    try {
      this.setState({
        currentDiffcultyId: index,
        hadFeedBack: true,
      })
      const args = {
        message: (
          <span>
            <Icon
              type="check-circle"
              style={{ marginRight: 6, color: 'green' }}
            />
            难度反馈提交成功
          </span>
        ),
        description: '感谢您的反馈!',
        duration: 2,
      }
      notification.open(args)
    } catch (e) {}
  }
  renderSingleChoice = () => {
    const { answer, showAnwser } = this.state
    const options = this.props.options

    return (
      <RadioGroup
        disabled={showAnwser}
        name="radiogroup"
        defaultValue={1}
        onChange={this.handleChoice}
      >
        {options.map((item, i) => (
          <Radio key={i} className={styles.radioItem} value={item.value}>
            <span
              style={{ display: 'flex' }}
              dangerouslySetInnerHTML={{
                __html: `${item.order}.${item.text}`,
              }}
            />
          </Radio>
        ))}
      </RadioGroup>
    )
  }

  renderMutiChoice = () => {
    const { answer, showAnwser } = this.state
    const options = this.props.options
    return (
      <div className={styles.mutiChoice}>
        <Checkbox.Group disabled={showAnwser} onChange={this.handleMutiChoice}>
          {options.map((item, i) => (
            <Checkbox key={i} className={styles.radioItem} value={item.value}>
              <span
                style={{ display: 'flex' }}
                dangerouslySetInnerHTML={{
                  __html: `${item.order}.${item.text}`,
                }}
              />
            </Checkbox>
          ))}
        </Checkbox.Group>
        {!showAnwser && (
          <Button
            disabled={answer[0].length < 2}
            onClick={this.handleConfirm}
            style={{ width: 74, marginBottom: 14 }}
            type="primary"
          >
            确定
          </Button>
        )}
      </div>
    )
  }

  renderCompletion = () => {
    const { answer, showAnwser } = this.state
    const { answer_count } = this.props
    return (
      <div>
        <div>
          {Array(answer_count || 1)
            .fill('')
            .map((x, idx) => (
              <TextArea
                key={idx}
                rows={1}
                disabled={showAnwser}
                autosize
                value={answer[idx]}
                style={{
                  width: `${940 / Number(answer_count) - 10}px`,
                  margin: '0 5px 14px',
                }}
                onChange={e => this.handleCompletionInput(e, idx)}
              />
            ))}
        </div>

        {!showAnwser && (
          <Button
            disabled={!answer.some(x => !!x)}
            onClick={this.handleConfirm}
            type="primary"
          >
            确定
          </Button>
        )}
      </div>
    )
  }
  renderIntegration = () => {
    const { answer, showAnwser } = this.state
    return (
      <div>
        <TextArea
          disabled={showAnwser}
          style={{ marginBottom: 14 }}
          autosize={{ minRows: 4 }}
          rows={4}
          onChange={this.handleInput}
          value={answer}
        />
        {!showAnwser && (
          <div>
            <Button
              disabled={!answer[0]}
              onClick={this.handleConfirm}
              type="primary"
              style={{ marginRight: 10 }}
            >
              确定
            </Button>
          </div>
        )}
      </div>
    )
  }
  render() {
    const {
      collape,
      answer,
      showAnwser,
      reaction,
      activeKey,
      currentDiffcultyId,
    } = this.state
    const { index, type, content } = this.props
    return (
      <div className={styles.exerciseCard}>
        <h4>
          <span style={{ display: 'flex' }}>
            {index}.
            <span
              className={styles.cardTitle}
              dangerouslySetInnerHTML={{
                __html: `<span class=${styles.type}>【${type}】</span><span>${content}</span>`,
              }}
            />
          </span>
          {this.props.operator}
        </h4>
        {this.renderExerciseByType(type)()}
        {showAnwser && (
          <Collapse
            onChange={this.test}
            bordered={false}
            activeKey={this.state.activeKey}
          >
            <Panel
              header={
                <div className={styles.answerTitle}>
                  <p>
                    您的答案：
                    <span style={{ color: '#E42626' }}>
                      <Tooltip title={answer && answer.toString()}>
                        {answer && answerFormatter(answer.toString(), 20)}
                      </Tooltip>
                      {!noNeedStatistics.includes(type) && (
                        <>
                          参考答案：
                          <span>
                            {reaction.answers &&
                              answerFormatter(reaction.answers.toString(), 30)}
                          </span>
                        </>
                      )}
                    </span>
                    {/* {type !== '综合' && <span>{reaction.meta.message}</span>} */}
                  </p>
                  <i>{!activeKey ? '展开解析' : '收起解析'}</i>
                </div>
              }
              key="1"
            >
              <div className={styles.answerContent}>
                {noNeedStatistics.includes(type) && (
                  <p>
                    <span className={styles.label} style={{ minWidth: 70 }}>
                      参考答案：
                    </span>
                    <span>
                      {reaction.answers &&
                        answerFormatter(reaction.answers.toString(), 100000)}
                    </span>
                  </p>
                )}
                {!noNeedStatistics.includes(type) && (
                  <p>
                    <span className={styles.label}>统计：</span>本题共被作答
                    {reaction.answered_count}
                    次，正确率 {reaction.right_rate} ，易错项是
                    {reaction.fallibility}
                  </p>
                )}
                <p>
                  <span className={styles.label}>解析：</span>

                  <span
                    className={styles.cardTitle}
                    dangerouslySetInnerHTML={{
                      __html: `${reaction.analysis}`,
                    }}
                  />
                </p>
                {/* <p>
                  <span className={styles.label}>难易：</span>
                  {['容易', '一般', '困难'].map((item, idx) => (
                    <span
                      key={item}
                      className={`${styles.btn} ${
                        currentDiffcultyId === idx ? styles.active : undefined
                      }`}
                      onClick={() =>
                        !this.state.hadFeedBack
                          ? this.handlePostTitleDiffculty(item, idx)
                          : undefined
                      }
                    >
                      {item}
                    </span>
                  ))}
                </p> */}
              </div>
            </Panel>
          </Collapse>
        )}
      </div>
    )
  }
}

export default ExerciseCard
